export default __webpack_public_path__ + "static/medal-b8b798f526e05f863470b242405d9680.png";